import assert from 'assert';
import debounce from 'lodash/debounce';
import handleEventMap from '../common/handleEventMap';
import handleToggle from '../common/handleToggle';
import getSelectionData from '../common/getSelectionData';
import handleFilterEnable from './handleFilterEnable';
import handleItemRemove from './handleItemRemove';
import handleReset from './handleReset';
import handleSummaryUpdate from './handleSummaryUpdate';

/**
 * Attach interactions to every element that matches selector.
 */
$('.filter').each((_, filter) => {
    // validate filter element
    assert(filter.tagName.match(/form/i), 'Filter has to be a form element.');

    // detach and cache summary item template
    const $summaryItemTemplate = $(filter).find('.filter__summary__item[data-template]')
        .removeAttr('data-template')
        .detach();

    // add event listeners
    $(filter)
        .on('select:change', debounce(handleSummaryUpdate(filter, $summaryItemTemplate)))
        .on('select:change', debounce(handleEventMap(filter, 'filter:change', getSelectionData)))
        .on('click', '.filter__toggle', handleToggle(filter))
        .on('click', '.filter__summary__item', handleItemRemove(filter))
        .on('click', '.filter__summary__reset', handleReset(filter))
        .on('filter:enable', handleFilterEnable(filter));

    $(window).on('load', handleSummaryUpdate(filter, $summaryItemTemplate));
});



// WEBPACK FOOTER //
// ./src/scripts/components/filter/index.js